package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebIcon
import com.merkost.handpass.sharedweb.components.WebEmptyState

@Composable
fun AdminEmptyState(
    title: String,
    description: String? = null,
    actionLabel: String? = null,
    onAction: (() -> Unit)? = null,
    icon: WebIcon = WebIcon.Queue,
) {
    WebEmptyState(
        icon = icon,
        title = title,
        message = description,
        actionLabel = actionLabel,
        onAction = onAction,
    )
}

@Composable
fun AdminQueueAllClear() {
    AdminEmptyState(
        title = "All clear.",
        description = "Nothing pending. Take a break.",
        icon = WebIcon.Check,
    )
}
